import script from "./store.vue?vue&type=script&setup=true&lang=ts"
export * from "./store.vue?vue&type=script&setup=true&lang=ts"

import "./store.vue?vue&type=style&index=0&id=08e0e0ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08e0e0ab"]])

export default __exports__